<template>
  <transition name="zoom">
    <div class="page-content">
      <el-card v-loading="loading"
               class="page-box detail-box"
               shadow="never">
        <div slot="header" class="clearfix">
          <div class="title">基础信息</div>
          <span class="close"  @click="closeEdit">
            <icon-svg iconClass="close-small"></icon-svg>
          </span>
        </div>
        <div class="appl-info">
          <el-form
            :model="orderForm"
            :rules="rules"
            ref="orderForm"
            label-width="100px">
            <el-form-item label="客户名称" prop="memberId">
              <el-select
                v-model="orderForm.memberId"
                filterable
                remote
                reserve-keyword
                placeholder="请输入客户名称或手机号搜索"
                :remote-method="memberMethod"
                :loading="memberLoading"
                @change="memberChange"
                @focus="memberFocus">
                <el-option
                  v-for="item in members"
                  :key="item.memberId"
                  :label="item.name"
                  :value="item.memberId"
                  style="width: 300px;">
                  <span style="float: left">{{ item.name }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.phone }}</span>
                </el-option>
              </el-select>
              <el-button type="text" @click="addMember">&nbsp;&nbsp;新增会员</el-button>
            </el-form-item>
            <el-form-item label="联系方式" prop="phone">
              <el-input v-model="orderForm.phone" placeholder="请输入联系方式"></el-input>
            </el-form-item>
            <el-form-item label="预约时间" prop="orderTime">
              <el-date-picker
                v-model="orderForm.orderTime"
                type="datetime"
                placeholder="请选择日期时间"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="服务时间" prop="intervalDate">
              <el-date-picker
                v-model="orderForm.intervalDate"
                type="daterange"
                range-separator="至"
                start-placeholder="请选择开始服务时间"
                end-placeholder="请选择结束服务时间"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="服务地址" prop="addr">
              <el-input v-model="orderForm.addr" placeholder="请输入服务地址"></el-input>
            </el-form-item>
            <el-form-item label="负责人" prop="leaderId">
              <el-select
                v-model="orderForm.leaderId"
                filterable
                remote
                reserve-keyword
                placeholder="请输入员工姓名搜索"
                :remote-method="employeeMethod"
                :loading="employeeLoading"
                @change="employeeChange">
                <el-option
                  v-for="item in employees"
                  :key="item.employeeId"
                  :label="item.name"
                  :value="item.employeeId"
                  style="width: 300px;">
                  <span style="float: left">{{ item.name }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.deptName }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="特殊说明" placeholder="请输入特殊说明" prop="tsRemark">
              <el-input type="textarea" v-model="orderForm.tsRemark"></el-input>
            </el-form-item>
            <el-form-item label="备注" placeholder="请输入备注" prop="remark">
              <el-input type="textarea" v-model="orderForm.remark"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="order-info">
          <div class="title-no">
            <div class="add-but">服务方案</div>
            <el-button
              type="primary"
              style="width: 140px; float: right"
              @click="dialogVisible = true">+ 添加服务方案
            </el-button>
          </div>
          <el-table
            :data="orderForm.orderDetailList"
            style="width: 100%">
            <el-table-column
              prop="serviceName"
              label="服务名称">
            </el-table-column>
            <el-table-column
              prop="serviceUnitPrice"
              label="服务单价">
            </el-table-column>
            <el-table-column
              prop="servicePrice"
              label="本次服务价格">
              <template slot-scope="{row}">
                <el-form
                  :model="row"
                  :rules="rules"
                  ref="orderDetail"
                  style="width: 180px">
                  <el-form-item prop="servicePrice">
                    <el-input
                      style="width: 180px;"
                      autocomplete="off"
                      v-model="row.servicePrice"
                      placeholder="服务单价"
                    ></el-input>
                  </el-form-item>
                </el-form>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              width="140">
              <template slot-scope="{row}">
                <div class="link" @click="deleteService(row.$index)">删除</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="total-money">总计： {{totalMoney}}元</div>
        <div class="close-win">
          <el-button @click="closeEdit">关闭</el-button>
          <el-button type="primary" style="width: 100px" @click="submitForm('ruleForm')">{{buttonName}}</el-button>
        </div>
      </el-card>
      <el-dialog
        title="添加服务方案"
        :visible.sync="dialogVisible"
        width="40%"
        :modal="false">
        <el-form
          :model="service"
          label-width="200px"
          :rules="rules"
          ref="service">
          <el-form-item label="服务名称" prop="serviceCodes">
            <el-cascader
              :options="serviceItems"
              v-model="service.serviceCodes"
              @change="handleChange"
              style="width: 200px;"
              placeholder="请选择服务名称"
              :props="defaultProps">
            </el-cascader>
          </el-form-item>
          <el-form-item label="服务单价" prop="serviceUnitPrice">
            <el-input
              v-model.number="service.serviceUnitPrice"
              disabled
              type="Number"
              autocomplete="off"
              style="width: 200px;"
              placeholder="请输入实际价格">
            </el-input>
          </el-form-item>
          <el-form-item label="实际价格" prop="servicePrice">
            <el-input
              v-model="service.servicePrice"
              autocomplete="off"
              style="width: 200px;"
              placeholder="请选择服务单价">
            </el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="addServe" :loading="serviceLoading">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </transition>
</template>

<script>
import {member, employee, order, serve} from '@/api'
import {checkMoney, checkPhone} from '@/utils'
export default {
  name: 'PolicyDetail',
  components: {},
  props: {
    param: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      buttonName: '立即创建',
      firstLoading: true,
      serviceLoading: false,
      serviceItems: [],
      service: {
        serviceCodes: [],
        serviceName: '',
        serviceId: 0,
        serviceUnitPrice: 0,
        servicePrice: 0
      },
      defaultProps: {
        label: 'name',
        value: 'id'
      },
      members: [],
      memberAll: [],
      memberLoading: false,
      isGetEmployees: false,
      employees: [],
      employeeAll: [],
      employeeLoading: false,
      tableData: [],
      dialogVisible: false,
      orderForm: {
        memberId: '',
        phone: '',
        orderTime: null,
        intervalDate: '',
        addr: '',
        leaderId: '',
        tsRemark: '',
        remark: '',
        orgCode: this.$store.state.user.orgCode,
        orderDetailList: []
      },
      loading: false,
      rules: {
        servicePrice: [
          { required: true, message: '请输入实际价格', trigger: 'blur' },
          {validator: checkMoney, trigger: 'blur'}
        ],
        serviceCodes: [
          { required: true, message: '请选择服务名称', trigger: 'blur' }
        ],
        memberId: [
          { required: true, message: '请输入客户名称', trigger: 'blur' },
          { max: 64, message: '长度过长', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请填写手机号', trigger: 'blur' },
          {validator: checkPhone, trigger: 'blur'}
        ],
        orderTime: [
          { required: true, message: '请填写预约时间', trigger: 'blur' }
        ],
        intervalDate: [
          { required: false, message: '请填写服务时间', trigger: 'blur' }
        ],
        addr: [
          { required: true, message: '请填写服务地址', trigger: 'blur' },
          { max: 255, message: '长度过长', trigger: 'blur' }
        ],
        leaderId: [
          { required: true, message: '请填写负责人', trigger: 'blur' }
        ],
        tsRemark: [
          { max: 255, message: '长度过长', trigger: 'blur' }
        ],
        remark: [
          { max: 255, message: '长度过长', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.getMemberAll('')
    this.getEmployeeAll('')
    this.getSelService('')
  },
  computed: {
    totalMoney: function () {
      let money = 0
      for (let entity of this.orderForm.orderDetailList) {
        money += parseFloat(entity.servicePrice)
      }
      return money.toFixed(2)
    }
  },
  methods: {
    changeEvent (value) {
      if (value === 'new') {
        this.buttonName = '立即创建'
        this.newApple()
      } else {
        this.buttonName = '保存修改'
        this.updateApple(value)
      }
    },
    newApple () {
      this.orderForm.orderDetailList = []
      this.orderForm['createUser'] = this.$store.state.user.userId
    },
    updateApple (value) {
      this.getData(value)
    },
    addMember () {
      this.isGetEmployees = true
      this.$router.push(this.$route.path + '/add')
    },
    employeeChange (value) {
      let orderForm = this.employees.find((elem) => {
        return elem.employeeId === value
      })
      this.orderForm['leaderName'] = orderForm.name
    },
    memberChange (value) {
      let orderForm = this.members.find((elem) => {
        return elem.memberId === value
      })
      this.orderForm['name'] = orderForm.name
      this.orderForm['phone'] = orderForm.phone
      this.orderForm['addr'] = orderForm.addr
    },
    submitForm () {
      let self = this
      this.$refs['orderForm'].validate((valid) => {
        if (valid) {
          if (self.orderForm.orderDetailList.length === 0) {
            this.$message('请添加服务方案')
          } else {
            this.$refs['orderDetail'].validate((validDetail) => {
              if (validDetail) {
                if (this.param === 'new') this.postAddForm()
                else this.postUpdateForm()
              }
            })
          }
        } else {
          return false
        }
      })
    },
    async postUpdateForm () {
      this.loading = true
      this.orderForm['orderAmount'] = this.totalMoney
      let {code, data} = await order.updateOrderFrom(this.orderForm)
      this.loading = false
      if (code === 0) {
        this.$message({
          message: '服务预约编辑成功！',
          type: 'success'
        })
        this.$emit('order-view', 'order-list', 'flush')
      } else {
        this.$message('网络错误，请稍后重试')
      }
    },
    async postAddForm () {
      this.loading = true
      this.orderForm['orderAmount'] = this.totalMoney
      let {code, data} = await order.addOrderFrom(this.orderForm)
      this.loading = false
      if (code === 0) {
        this.$message({
          message: '服务预约添加成功！',
          type: 'success'
        })
        this.$refs['orderForm'].resetFields()
        this.$emit('order-view', 'order-list', 'flush')
      } else {
        this.$message('网络错误，请稍后重试')
      }
    },
    deleteService (index) {
      this.$confirm('是否删除此服务方案?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.orderForm.orderDetailList.splice(index, 1)
      })
    },
    addServe () {
      let self = this
      this.$refs['service'].validate((valid) => {
        if (valid) {
          let { servicePrice, serviceName, serviceId, serviceUnitPrice } = self.service
          self.orderForm.orderDetailList.push({servicePrice, serviceName, serviceId, serviceUnitPrice})
          self.service.serviceUnitPrice = 0
          self.$refs['service'].resetFields()
          self.dialogVisible = false
        } else {
          return false
        }
      })
    },
    async getSelService () {
      let {data} = await serve.getSelTree(this.$store.state.user.orgCode)
      this.serviceItems = data
    },
    async handleChange (value) {
      if (value.length > 1) {
        this.serviceLoading = true
        let serviceId = value[value.length - 1]
        let {data} = await serve.getServeDetail(serviceId)
        this.serviceLoading = false
        this.service.serviceUnitPrice = data.price
        this.service.servicePrice = data.price
        this.service.serviceId = serviceId
        this.service.serviceName = data.serviceName
      }
    },
    async getMemberAll (value) {
      let {data} = await member.getMemberSelList({
        orgCode: this.$store.state.user.orgCode,
        parameter: value
      })
      this.memberLoading = false
      if (this.memberAll.length === 0) this.memberAll = data
      this.members = data
      return data
    },
    memberMethod (query) {
      if (query !== '') {
        this.memberLoading = true
        this.getMemberAll(query)
      } else {
        this.members = this.memberAll
      }
    },
    memberFocus () {
      if (this.isGetEmployees) {
        this.isGetEmployees = false
        this.members = this.getMemberAll('')
      }
    },
    async getEmployeeAll (value) {
      let {data} = await employee.getEmployeeList({
        orgCode: this.$store.state.user.orgCode,
        name: value
      })
      this.employeeLoading = false
      if (this.employeeAll.length === 0) this.employeeAll = data
      this.employees = data
      return data
    },
    employeeMethod (query) {
      if (query !== '') {
        this.employeeLoading = true
        this.getEmployeeAll(query)
      } else {
        this.employees = this.employeeAll
      }
    },
    async getData (param) {
      this.loading = true
      let {data} = await order.getOrderDetail(param)
      this.orderForm = data
      this.orderForm['updateUser'] = this.$store.state.user.userId
      this.loading = false
      // let self = this
      // setTimeout(() => {
      //   if (self.orderForm.leaderId) {
      //     let employee = self.employeeAll.find((elem) => {
      //       return elem.employeeId === self.orderForm.leaderId
      //     })
      //     if (!employee) {
      //       self.employeeAll.push({
      //         employeeId: self.orderForm.leaderId,
      //         name: self.orderForm.leaderName
      //       })
      //     }
      //   }
      // }, 300)
    },
    closeEdit () {
      this.$refs['orderForm'].resetFields()
      this.$emit('order-view', 'order-list')
    }
  }
}
</script>

<style lang="scss" scoped>
  .appl-info {
    margin-top: 20px;
    .el-select {
      width: 56%
    }
    .el-input {
      width: 66.6%
    }
    .el-textarea {
      width: 66.6%
    }
  }
  .page-content {
    min-width: 1000px;
  }
  .add-but {
    display: inline;
  }
  .el-card {
    top: 20px;
    right: 20px;
    left: 20px;
    z-index: 2;
    margin-bottom: 0;
    background-color: #fff;
    /deep/ .el-card__header {
      padding: 0 0 10px 0;
      .title {
        font-size: 16px;
        font-weight: 500;
      }
    }
    .close {
      margin-top: -30px;
      float: right;
      .svg-icon {
        width: 2em;
        height: 2em;
      }
    }
    /deep/ .el-card__body {
      padding: 0;
    }
    .close-win {
      text-align: center;
      margin: 20px 0 10px 0;
    }
    .total-money {
      margin-top: 10px;
    }
  }

</style>
